import {
    normalizeChartingCorporateActions,
    normalizeChartingFundamental,
    normalizeChartingFundamentalEmployees,
    normalizeChartingOhlcSeriesWithCorporateActions,
    normalizeChartingStreamingState
} from '@/features/charting-next/adapters/chartingInsightsAdapters';
import { get } from '@/features/charting-next/api/chartingRepositoryClient';

export async function fetchChartingStreamingState() {
    const payload = await get('/api/v1/frontend/streaming/is_live');

    return normalizeChartingStreamingState(payload);
}

export async function fetchChartingFundamental(ticker = '') {
    const normalizedTicker = String(ticker || '')
        .trim()
        .toUpperCase();

    if (!normalizedTicker) {
        return normalizeChartingFundamental({});
    }

    const payload = await get(`/api/v1/stocks/fundamental/${encodeURIComponent(normalizedTicker)}`);

    return normalizeChartingFundamental(payload);
}

export async function fetchChartingFundamentalEmployees(ticker = '') {
    const normalizedTicker = String(ticker || '')
        .trim()
        .toUpperCase();

    if (!normalizedTicker) {
        return normalizeChartingFundamentalEmployees([]);
    }

    const payload = await get(`/api/v1/stocks/scrap_employees/${encodeURIComponent(normalizedTicker)}`);

    return normalizeChartingFundamentalEmployees(payload);
}

export async function fetchChartingFirstOhlc(ticker) {
    const payload = await get('/stockchart/api/history/firstohlc', {
        params: {
            symbol: ticker
        }
    });

    return Number(payload) || 0;
}

export async function fetchChartingOhlcSeries(ticker, resolution = 'D') {
    const normalizedTicker = String(ticker || '')
        .trim()
        .toUpperCase();
    const normalizedResolution = ['D', 'W', 'M'].includes(resolution) ? resolution : 'D';

    if (!normalizedTicker) {
        return normalizeChartingOhlcSeriesWithCorporateActions({});
    }

    const firstTimestamp = await fetchChartingFirstOhlc(normalizedTicker);
    const to = Math.floor(Date.now() / 1000);
    const fallbackLookback = normalizedResolution === 'D' ? 60 * 60 * 24 * 365 * 5 : 60 * 60 * 24 * 365 * 12;
    const from = firstTimestamp > 0 ? firstTimestamp : to - fallbackLookback;

    const [payload, corporateActions] = await Promise.all([
        get('/stockchart/api/history', {
            params: {
                symbol: normalizedTicker,
                resolution: normalizedResolution,
                from,
                to
            }
        }),
        get('/stockchart/api/timescale_marks', {
            params: {
                symbol: normalizedTicker,
                resolution: normalizedResolution,
                from,
                to
            }
        })
            .then((marks) => normalizeChartingCorporateActions(marks))
            .catch(() => [])
    ]);

    return normalizeChartingOhlcSeriesWithCorporateActions(payload, corporateActions);
}

export async function fetchChartingMobileOhlcSeries(ticker, resolution = 'D') {
    const normalizedTicker = String(ticker || '')
        .trim()
        .toUpperCase();
    const normalizedResolution = ['D', 'W', 'M'].includes(resolution) ? resolution : 'D';

    if (!normalizedTicker) {
        return normalizeChartingOhlcSeriesWithCorporateActions({});
    }

    const payload = await get('/stockchart/api/history', {
        params: {
            symbol: normalizedTicker,
            resolution: normalizedResolution,
            from: 0,
            to: Math.floor(Date.now() / 1000)
        }
    });

    return normalizeChartingOhlcSeriesWithCorporateActions(payload, []);
}
